import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils';

const badgeVariants = cva(
    'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'border-transparent bg-primary text-primary-foreground shadow-sm',
                secondary: 'border-transparent bg-secondary text-secondary-foreground shadow-sm',
                success: 'border-transparent bg-secondary text-secondary-foreground shadow-sm',
                destructive: 'border-transparent bg-destructive text-destructive-foreground shadow-sm',
                warning: 'border-transparent bg-yellow-500 text-white shadow-sm',
                outline: 'text-foreground border-primary',
                accent: 'border-transparent bg-accent-acqua/20 text-primary border-accent-acqua/30',
                // Brighter solid variants for pipeline/status tags
                'green-solid': 'border-0 bg-green-500 text-white shadow-sm',
                'blue-solid': 'border-0 bg-blue-500 text-white shadow-sm',
                'blue-dark': 'border-0 bg-blue-800 text-white shadow-sm',
                'amber-solid': 'border-0 bg-amber-500 text-white shadow-sm',
                'indigo-solid': 'border-0 bg-indigo-500 text-white shadow-sm',
                'violet-solid': 'border-0 bg-violet-500 text-white shadow-sm',
                'red-solid': 'border-0 bg-red-500 text-white shadow-sm',
                'gray-solid': 'border-0 bg-gray-500 text-white shadow-sm',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
});
Badge.displayName = 'Badge';

export { Badge, badgeVariants };
